var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"text-lg font-light text-left whitespace-nowrap",class:{
    'text-white': _vm.textColor !== '' && typeof _vm.textColor !== 'undefined',
    'text-brand-promo-bg':
      _vm.textColor === '' || typeof _vm.textColor === 'undefined',
  }},[_c('a',{staticClass:"border-b cursor-pointer w-full inline-block",class:{
      'border-white': _vm.textColor !== '' && typeof _vm.textColor !== 'undefined',
      'border-brand-promo-bg':
        _vm.textColor === '' || typeof _vm.textColor === 'undefined',
    },attrs:{"href":_vm.link,"target":_vm.target !== 'undefined' ? _vm.target : '_self'}},[_vm._t("default"),_vm._v(" "),_c('svg',{staticClass:"inline-block h-4 ml-1 mr-2",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 8.167 21.079"}},[_c('path',{attrs:{"fill":"none","stroke":"currentcolor","stroke-width":"1.5px","d":"M3471.226,2026.9l6.642,10.184-6.642,10.073","transform":"translate(-3470.597 -2026.494)"}})])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }